import { colors, typography } from '@mehilainen/mds-tokens';
import { baseTypography } from '@mehilainen/mds-tokens/typography';
import { paginationItemClasses, } from '@mui/material';
import { focusVisible, muiFocusVisibleCssClass } from '../shared';
/*
 * Note: _tokens are provided for future reference
 * Rename to tokens if used
 */
export const getThemePagination = (_tokens) => ({
    MuiPagination: {
        defaultProps: {
            shape: 'rounded',
            variant: 'outlined',
            size: 'large',
        },
    },
    MuiPaginationItem: {
        defaultProps: {},
        styleOverrides: {
            outlined: Object.assign(Object.assign({}, typography.textStyle300MediumHeightL), { color: colors.Primary500, margin: '0 4px', 
                // Ellipsis is also a paginationitem
                [`:not(.${paginationItemClasses.ellipsis})`]: {
                    border: `2px solid ${colors.Gray300}`,
                    backgroundColor: colors.White,
                    '&:hover': {
                        borderWidth: '2px',
                        backgroundColor: colors.White,
                        borderColor: colors.Primary500,
                    },
                    [`&${muiFocusVisibleCssClass}`]: Object.assign(Object.assign({}, focusVisible), { outlineOffset: '2px' }),
                    '&.Mui-selected': {
                        border: 'unset',
                        backgroundColor: colors.Primary500,
                        color: colors.White,
                        '&:hover': {
                            backgroundColor: colors.Success400,
                        },
                        [`&${muiFocusVisibleCssClass}`]: Object.assign(Object.assign({}, focusVisible), { backgroundColor: colors.Success400, outlineOffset: '2px' }),
                    },
                } }),
            ellipsis: {
                minWidth: 'unset',
                fontWeight: baseTypography.weight.Bold,
                color: colors.Gray500,
                padding: '4px 4px 6px',
                [`&.${paginationItemClasses.sizeLarge}`]: {
                    padding: '5px 5px 7px',
                },
                [`&.${paginationItemClasses.sizeSmall}`]: {
                    padding: '3px 3px 5px',
                },
            },
        },
    },
    // NOTE: TablePagination is written to ./table.ts
});
